import React from 'react';
import { Alert } from '@thd-olt-component-react/core-ui';
import './discontinued.scss';
import { bool } from 'prop-types';

const Discontinued = ({ twoTileToggle }) => {
  return twoTileToggle ? (
    <div className="fulfillment__unavailable">
      <div className="discontinued__wrapper">
        <div className="discontinued__two-tile-header">This Item is Discontinued</div>
        <div className="discontinued__content">We no longer carry this particular product.</div>
      </div>
    </div>
  ) : (
    <div className="fulfillment__unavailable">
      <fieldset className="fulfillment__unavailable--fieldset">
        <legend className="fulfillment__unavailable--title">How To Get it</legend>
        <div className="discontinued__wrapper">
          <Alert
            title="Discontinued!"
            type="danger"
            message="We are no longer carrying this particular product."
            inline
          />
        </div>
      </fieldset>
    </div>
  );
};

Discontinued.propTypes = {
  twoTileToggle: bool
};

Discontinued.defaultProps = {
  twoTileToggle: false
};

export { Discontinued };
